///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch } from "react-redux";

import { saveNotificationSettings } from "../../slices/notificationsSlice";

const NotificationSettingRow = props => {
  const {
    description,
    email,
    unSavedEmail,
    unSavedBrowser,
    browser
  } = props;

  const dispatch = useDispatch();
  const toggleSetting = setting => () =>
    dispatch(
      saveNotificationSettings([
        {
          notificationSettingId: props.notificationSettingId,
          notificationSubTypes: props.notificationSubTypes,
          email: props.email,
          browser: props.browser,
          [setting]: !props[setting]
        }
      ])
    );

  return (
    <tr>
      <td className="one-half py-16 pl-28">{description}</td>
      <td className="one-quarter py-16 pl-32">
        <input
          className="pointer"
          type="checkbox"
          checked={unSavedEmail ?? email}
          onChange={toggleSetting("email")}
          disabled={unSavedEmail !== undefined}
        />
      </td>
      <td className="one-quarter py-16 pl-32">
        <input
          className="pointer"
          type="checkbox"
          checked={unSavedBrowser ?? browser}
          onChange={toggleSetting("browser")}
          disabled={unSavedBrowser !== undefined}
        />
      </td>
    </tr>
  );
};

export default NotificationSettingRow;
